import themeBase from "./themeBase";
import palette from "../palettes/defaultPalettes/pastelFade";

const factory = (p = palette, fontSizeCalculator) => {
  const base = themeBase(p);

  return {
    id: "pastelFade",
    label: "Pastel Fade",
    main: {
      ...base.main,
      textTransform: "uppercase",
      fontSize: fontSizeCalculator(16),
      // display: "inline-block",
    },
    container: {
      ...base.container,
      borderWidth: "1px 0px 1px 1px",
      borderStyle: "solid",
      borderColor: p.grid,
    },
    menu: {
      header: {
        wrapper: {
          ...base.menu.header.wrapper,
        },
        style: {
          ...base.menu.header.style,
          fontFamily: "Courier",
          textAlign: "center",
          fontSize: fontSizeCalculator(70),
          letterSpacing: "3.4px",
          padding: "30px",
        },
      },
      table: {
        style: {
          ...base.menu.table.style,
          fontFamily: "Open Sans",
          borderCollapse: "unset",
        },
        header: {
          style: {
            ...base.menu.table.header.style,
            padding: "30px 15px 20px",
            borderWidth: "0px 1px 1px 0px",
            borderStyle: "solid",
            borderColor: p.grid,
            fontSize: fontSizeCalculator(30),
          },
          overrides: {
            ...base.menu.table.header.overrides,
          },
        },
        data: {
          style: {
            ...base.menu.table.data.style,
            borderWidth: "0px 1px 1px 0px",
            borderStyle: "solid",
            borderColor: p.grid,
            fontSize: fontSizeCalculator(25),
          },
          overrides: {
            ...base.menu.table.data.overrides,
          },
        },
      },
    },
    specialSettings: {
      ...base.specialSettings,
    },
    advertisement: {
      ...base.advertisement,
    },
    content: {
      ...base.content,
    },
  };
};

export default factory;
